import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { FormQuestion, FormQuestionType } from 'api/form';
import { Radio } from 'components/atoms/radio';
import {
  FormItemWrapper,
  FormItemDesc,
  FormItemLabel,
  FieldsErrorRenderer,
  FormFieldProps,
} from './form-elements';
import {
  GridTable,
  RowInputError,
  getGridColumns,
  getGridColumnNames,
} from './matrix-question-components';

const RadioItem = styled(Radio)`
  display: flex;
  .ant-radio {
    margin-top: var(--spacing-01);
  }
`;

export const CheckBoxGridField: FC<FormFieldProps> = ({
  field,
  control,
  setValue,
  errors,
  disabled,
  renderRowErrorObject,
}) => {
  const fieldItem = field;

  const gridColumns = getGridColumns(fieldItem);

  const gridColumnNames = getGridColumnNames(gridColumns);

  const gridDataSource = (props: any, isDisabled: boolean) => {
    if (fieldItem !== undefined) {
      return fieldItem?.rows?.map((row: FormQuestion, index) => {
        const valueForThisQuestion = props.field.value ?? {};
        const currentValueForRow = valueForThisQuestion[row.questionId];
        const mappedData = gridColumnNames.reduce((acc: any, curr) => {
          if (curr.title === '') {
            acc.rowName = row.questionText;
          } else {
            acc[curr.title] = (
              <RadioItem
                disabled={isDisabled}
                type="radio"
                checked={
                  !!currentValueForRow?.find((item) => item === curr.key) ||
                  false
                }
                name={String(row.questionId)}
                value={curr.key}
                onChange={() => {
                  const valueForThisRow = curr.key;

                  valueForThisQuestion[row.questionId] = [valueForThisRow];
                  setValue?.(
                    field.questionId?.toString(),
                    valueForThisQuestion,
                  );
                }}
              />
            );
          }

          return acc;
        }, {});

        return { key: index, ...mappedData };
      });
    }

    return [];
  };

  return (
    <FormItemWrapper>
      <FormItemLabel label={field.questionText} required={field.required} />
      <FormItemDesc label={field.description} />
      <Controller
        control={control}
        rules={{ required: field.required }}
        name={field.questionId.toString()}
        shouldUnregister
        render={(props) => (
          <GridTable
            dataSource={gridDataSource(props, disabled)}
            columns={gridColumns}
            scroll={{ x: true }}
            isDisabled={disabled}
            pagination={false}
          />
        )}
      />

      <FieldsErrorRenderer
        errors={errors}
        questionId={field.questionId}
        questionType={FormQuestionType.CheckBoxGrid}
      />
      {renderRowErrorObject &&
      renderRowErrorObject[field.questionId] &&
      field.required ? (
        <RowInputError
          renderRowErrorObject={renderRowErrorObject}
          questionId={field.questionId}
          questionType={FormQuestionType.CheckBoxGrid}
        />
      ) : null}
    </FormItemWrapper>
  );
};
